export default "__VITE_ASSET__51aa1b1a__"